export default class ResponseError extends Error {
  constructor(responseError, ...params) {
    super(...params);

    this.message = responseError.toString();
    Object.keys(responseError.response).forEach((key) => {
      this[key] = responseError.response[key];
    });
  }
}



// WEBPACK FOOTER //
// ./src/libs/webcall/ResponseError.js